import { render, staticRenderFns } from "./tabbar.vue?vue&type=template&id=bce5dcba&scoped=true&lang=html&"
import script from "./tabbar.vue?vue&type=script&lang=js&"
export * from "./tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce5dcba",
  null
  
)

export default component.exports